import _ from 'lodash';
import { SelectOption } from 'global';
import { EQUIPMENT_CLASS, EQUIPMENT_MAKE } from '@trnsact/business-criteria';
import { DiscountType, EquipmentCondition, InventoryItemStatus } from '@trnsact/trnsact-shared-types';

import { convertEnumValuesToSelectOptions } from '../../../utils/selectOptionsHelper';

export const equipmentConditions: SelectOption[] = [
  { label: 'New', value: EquipmentCondition.New },
  { label: 'Used', value: EquipmentCondition.Used },
  { label: 'Reconditioned', value: EquipmentCondition.Reconditioned },
];

export const equipmentAttachmentTypes: SelectOption[] = [
  { label: 'Trailer', value: 'Trailer' },
  { label: 'Body', value: 'Body' },
  { label: 'Attachment', value: 'Attachment' },
];

export const discountTypes: SelectOption<DiscountType>[] = [
  { label: 'Flat', value: DiscountType.Flat },
  { label: 'Percentage', value: DiscountType.Percent },
];

export const makeOptions = convertEnumValuesToSelectOptions(EQUIPMENT_MAKE);

export const classOptions = convertEnumValuesToSelectOptions(EQUIPMENT_CLASS);

export const inventoryItemStatuses = convertEnumValuesToSelectOptions(InventoryItemStatus);

export const equipmentYears = _.range(1990, new Date().getFullYear() + 3)
  .reverse()
  .map(value => ({
    label: value.toString(),
    value: value.toString(),
  }));
